import { ModelFamilyEnum } from '@ztechapps/common.contract'

// Single source of truth for the model id -> ModelFamilyEnum editorial classification,
// shared by the QuickScore and hauler backfill/seed migrations and their api-test
// ModelRateSeed fixtures. This is a SUPERSET across both apps (e.g. `gpt-4o` is only
// billed by hauler) — an app-scoped bulkWrite/seed op whose filter matches no row in that
// app's `aimodelrates` collection is a safe no-op, so the same map applies verbatim to
// both databases. `family` has no derivable default (it is read off the version token in
// the model id per ModelFamilyEnum's granularity rule — vendor + product line + major
// generation), so this stays a hand-maintained map, never a computed/parsed function.
export const MODEL_FAMILY_BY_ID: Record<string, ModelFamilyEnum> = {
  'gpt-4': ModelFamilyEnum.OpenAiGpt4,
  'gpt-4o': ModelFamilyEnum.OpenAiGpt4,
  'gpt-4o-mini': ModelFamilyEnum.OpenAiGpt4,
  'gpt-4.1-nano': ModelFamilyEnum.OpenAiGpt4,
  'gpt-5': ModelFamilyEnum.OpenAiGpt5,
  'gpt-5-nano': ModelFamilyEnum.OpenAiGpt5,
  'gpt-5-mini': ModelFamilyEnum.OpenAiGpt5,
  'gpt-5.4': ModelFamilyEnum.OpenAiGpt5,
  'gpt-5.4-nano': ModelFamilyEnum.OpenAiGpt5,
  'gpt-5.4-mini': ModelFamilyEnum.OpenAiGpt5,
  'gpt-5.4-pro': ModelFamilyEnum.OpenAiGpt5,
  'gpt-5.5': ModelFamilyEnum.OpenAiGpt5,
  'gpt-5.5-pro': ModelFamilyEnum.OpenAiGpt5,
  'gpt-5.6-luna': ModelFamilyEnum.OpenAiGpt5,
  'gpt-5.6-terra': ModelFamilyEnum.OpenAiGpt5,
  'gpt-5.6-sol': ModelFamilyEnum.OpenAiGpt5,
  'gemini-2.5-flash': ModelFamilyEnum.GoogleGemini2,
  'gemini-2.5-flash-lite': ModelFamilyEnum.GoogleGemini2,
  'claude-haiku-4.5': ModelFamilyEnum.AnthropicClaude4,
  'deepseek-v3': ModelFamilyEnum.DeepSeekV3,
  'minimax-m2': ModelFamilyEnum.MiniMaxM2,
  'glm-ocr': ModelFamilyEnum.ZaiGlm,
}
